import { REMOTE_MEDIA_ARRAY } from "components/Home/VideoBarContainer/VideoBar/MediaArray/MediaArray.js";
export const SPACEBOX = document.getElementById("SPACEBOX");
export const REMOTE_ARRAY = document.getElementById(REMOTE_MEDIA_ARRAY);
export var myCircle = null;
export function setmyCircle(val) {
  myCircle = val;
}
export var fontHeight = 0;
export function setFontHeight(val) {
  fontHeight = val;
}
export var myLuid;
window.myLuid = () => window.log(myLuid);
export function SsetMyLuid(val) {
  myLuid = val;
}
export var avatarCircle = {};
export function setavatarCircle(val) {
  avatarCircle = val;
}
window.getAvatarCicle = () => window.log(avatarCircle);
export var sideVideos = {};
export function setSideVideos(val) {
  sideVideos = val;
}
export var people = {};
window.getpeople = () => window.log(people);
export function resetpeople(val) {
  people = {};
}
export var spaceBoxWidth;
export function setSpaceBoxWidth(val) {
  spaceBoxWidth = val;
}
export var spaceBoxHeight;
export function setSpaceBoxHeight(val) {
  spaceBoxHeight = val;
}
export var mediaRange;
export var audioClearRange;
export var videoClearRange;
export var audioModulateRange;
export var videoModulateRange;
export function setMediaRanges(val) {
  mediaRange = val;
  audioClearRange = mediaRange * 0.5;
  videoClearRange = mediaRange * 0.8;
  audioModulateRange = mediaRange - audioClearRange;
  videoModulateRange = mediaRange - videoClearRange;
}
export var iAmLocked;
export function setGraphicLockedValue(val) {
  iAmLocked = val;
}

export var edgeBuffer;
export const setEdgeBuffer = (val, spaceBoxWidth) => {
  edgeBuffer = val * spaceBoxWidth;
};
